import React from "react";
import "./movBanner.css";

function BlueWarningBanner() {
  return (
    <div className="blue_banner_wrapper">

      {/* TOP STRIP */}
      <div className="blue_tape blue_tape_dark">

        <div className="blue_tape_track">

          <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>

          <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>

          <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>
           <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>
           <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>
           <span>
             NEED QUICK HELP? (+971 52 174 3345)
          </span>

        </div>

      </div>

      {/* BOTTOM STRIP */}
      <div className="blue_tape blue_tape_light">

        <div className="blue_tape_track reverse_track">

          <span>
             AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>

          <span>
            AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>

          <span>
             AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>
           <span>
             AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>
           <span>
             AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>
          <span>
             AT YOUR DOORSTEP-IN MAX 30 MINUTES
          </span>

        </div>

      </div>

    </div>
  );
}

export default BlueWarningBanner;